"use client";

import { useEffect } from "react";
import { getCalApi } from "@calcom/embed-react";
import { trackMeetingBooked, identifyUser } from "@/lib/analytics";

interface PageWithCalModalProps {
  children: React.ReactNode;
}

export default function PageWithCalModal({ children }: PageWithCalModalProps) {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi();

      cal("ui", {
        theme: "dark",
        styles: {
          branding: { brandColor: "#D4A84B" },
        },
        hideEventTypeDetails: false,
      });

      // Capture successful bookings for analytics
      cal("on", {
        action: "bookingSuccessfulV2",
        callback: (e: any) => {
          const data = e.detail?.data;
          const attendee = data?.attendees?.[0];

          if (attendee?.email) {
            const [firstName, ...rest] = (attendee.name || "").split(" ");
            identifyUser({
              firstName: firstName || "",
              lastName: rest.join(" ") || "",
              emailAddress: attendee.email,
              linkedInUrl: attendee.LinkedIn || "",
            });
          }

          trackMeetingBooked({
            uid: data?.uid,
            title: data?.title,
            start_time: data?.startTime,
            end_time: data?.endTime,
            status: data?.status,
            linkedin_url: attendee?.LinkedIn || "",
          });
        },
      });
    })();

    const handleOpenModal = async (e: CustomEvent) => {
      const cal = await getCalApi();
      const link = e.detail.link || "momentumworld/30min";

      cal("modal", {
        calLink: link,
      });
    };

    window.addEventListener("openCalModal" as any, handleOpenModal);

    return () => {
      window.removeEventListener("openCalModal" as any, handleOpenModal);
    };
  }, []);

  return <>{children}</>;
}

// Helper function to open modal from anywhere
export function openCalModal(link: string = "momentumworld/30min") {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("openCalModal", { detail: { link } }));
  }
}
